import React from "react";
import { Link } from "react-router-dom";
import { NavbarBrand } from "reactstrap";
import styled from "styled-components";

const StyledNavbarBrand = styled(NavbarBrand)`
  padding-top: 0;
  padding-bottom: 0;
  margin: 0;
`;
const HeaderLogo = ({ logo, link }) => {
  return (
    <StyledNavbarBrand tag={Link} to={link}>
      <img className="navbar-logo" src={logo} alt="logo" />
    </StyledNavbarBrand>
  );
};

export default HeaderLogo;
